import QueryKeys from '@/utils/QueryKeys';
import { plato_api_states_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseState, StateSchema } from '@/types/api/v2/StateSchema';
import useApi from './useApi';

interface UseStatesParams<K extends (keyof BaseState)[]> {
  only?: K;
  params?: object;
}

type UseStatesOptions<K extends (keyof BaseState)[]> =
  UseStatesParams<K> & Omit<UseQueryOptions<StateSchema<K[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useStates<K extends(keyof BaseState)[]>({
  only,
  params = {},
  ...queryOptions
}: UseStatesOptions<K> = {} as UseStatesOptions<K>) {
  return useApi<StateSchema<K[number]>[], BaseState, K, never, []>({
    endpoint: plato_api_states_path({ only }),
    extra_attributes: [] as any,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.States, only],
    ...queryOptions,
  });
}
